import styled, { keyframes } from 'styled-components';
import { Media, HeaderSizes } from 'enums';
import { ZIndex } from 'config';
import { StyledSideBarProps } from './SideBar.model';

const fadeIn = keyframes`
  0% { transform: translateX(100%); opacity: 0 }
  100% { transform: translateX(0); opacity: 1 }
`;

const fadeOut = keyframes`
  0% { transform: translateX(0); opacity: 1 }
  100% { transform: translateX(100%); opacity: 0 }
`;

export const Container = styled.div<StyledSideBarProps>`
  position: fixed;
  top: ${HeaderSizes.mobile.height};
  right: 0;
  z-index: ${ZIndex.SideBar};

  width: 100%;
  height: calc(100vh - ${HeaderSizes.mobile.height});

  background: rgba(0, 0, 0, 0.15);

  animation: ${({ open }) => (open ? fadeIn : fadeOut)} 0.2s;
  animation-iteration-count: 1;
  animation-timing-function: ${({ open }) => (open ? 'ease-in' : 'ease-out')};
  animation-fill-mode: ${({ open }) => !open && 'forwards'};
`;

export const StyledMenu = styled.nav`
  position: inherit;
  right: 0;

  width: 100%;
  height: calc(100vh - ${HeaderSizes.mobile.height});

  background: ${({ theme }) => theme.colors.background};

  overflow-y: scroll;

  @media ${Media.tablet} {
    width: 464px;
  }
`;
